import Repository from "./repository"

const resource = 'notes'

export default {
    async addNote(payload) {
        let response = await Repository.post(`${resource}/note`, payload);
        return response;
    },
    async updateNote(payload) {
        let response = await Repository.put(`${resource}/${payload.note.roomId}/${payload.note.id}`, payload);
        return response;
    },
    async getNotes({ roomId }) {
        let url = `${resource}/${roomId}/notes`;
        let response = await Repository.get(url);
        return response;
    },
    async deleteNote({noteId}){
        let url = `${resource}/${noteId}`;
        let response = await Repository.delete(url);
        return response;
    }
}